var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98292 7.1968C6.19132 7.1968 7.17092 6.2172 7.17092 5.0088C7.17092 3.8004 6.19132 2.8208 4.98292 2.8208C3.77452 2.8208 2.79492 3.8004 2.79492 5.0088C2.79492 6.2172 3.77452 7.1968 4.98292 7.1968Z",
    fill: "#5B637C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23722 8.85518V20.9942H13.0062V14.9912C13.0062 13.4072 13.3042 11.8732 15.2682 11.8732C17.2052 11.8732 17.2292 13.6842 17.2292 15.0912V20.9952H21.0002V14.3382C21.0002 11.0682 20.2962 8.55518 16.4742 8.55518C14.6392 8.55518 13.4092 9.56218 12.9062 10.5152H12.8552V8.85518H9.23722ZM3.09521 8.85518H6.87021V20.9942H3.09521V8.85518Z",
    fill: "#5B637C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d47eba35d77f317e3fa6acbac545a4ed.svg";
export { ForwardRef as ReactComponent };